import React, {Component} from 'react'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'
import ImageUploaderDropZone from "../../../../common/image-uploader/dropzone.component.jsx"

const messages = defineMessages({
    "templates.sections.form.edit.content.image.size_15_label": {
        id: 'templates.sections.form.edit.content.image.size_15_label',
        defaultMessage: '15%',
    },
    "templates.sections.form.edit.content.image.size_25_label": {
        id: 'templates.sections.form.edit.content.image.size_25_label',
        defaultMessage: "25%",
    },
    "templates.sections.form.edit.content.image.size_50_label": {
        id: 'templates.sections.form.edit.content.image.size_50_label',
        defaultMessage: "50%",
    },
    "templates.sections.form.edit.content.image.size_75_label": {
        id: 'templates.sections.form.edit.content.image.size_75_label',
        defaultMessage: "75%",
    },
    "templates.sections.form.edit.content.image.size_100_label": {
        id: 'templates.sections.form.edit.content.image.size_100_label',
        defaultMessage: "100%",
    },
    "templates.sections.form.edit.content.image.alignment_left_label": {
        id:"templates.sections.form.edit.content.image.alignment_left_label",
        defaultMessage:"Left"
    },
    "templates.sections.form.edit.content.image.alignment_center_label": {
        id:"templates.sections.form.edit.content.image.alignment_center_label",
        defaultMessage:"Center"
    },
    "templates.sections.form.edit.content.image.alignment_right_label": {
        id:"templates.sections.form.edit.content.image.alignment_right_label",
        defaultMessage:"Right"
    },
    "templates.sections.form.edit.content.image.linkUrl_placeholder": {
        id:"templates.sections.form.edit.content.image.linkUrl_placeholder",
        defaultMessage:"https://www.tactiquote.com"
    }
})


class ImageContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            images: content.image ? [content.image] : [],
            image: content.image || null,
            imageId: content.imageId || '',
            alignment: content.alignment || 'center',
            size: content.size || '25',
            linkUrl: content.linkUrl || '',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            imageId: this.state.imageId,
            alignment: this.state.alignment,
            size: this.state.size,
            linkUrl: this.state.linkUrl,
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            image: content.image || null,
            imageId: content.imageId || '',
            alignment: content.alignment || 'center',
            size: content.size || '25',
            linkUrl: content.linkUrl || '',
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                images: images,
                image: images[0],
                imageId: images[0].id,
            }, this.triggerChanged)
        } else {
            this.setState({
                images: [],
                image: null,
                imageId: '',
            }, this.triggerChanged)
        }
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="title">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.image.image_label"
                            defaultMessage="Image"
                        />
                    </label>
                    <div className="col-10">
                        <ImageUploaderDropZone
                            onUpdateImageList={this.handleImageChange}
                            maxFiles={1}
                            images={this.state.images}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.image.image_description"
                                defaultMessage="Main image"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="size">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.image.size_label"
                            defaultMessage="Size"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="size"
                            value={this.state.size}
                            onChange={this.handleFormChange}
                            id="size"
                            className="form-control"
                        >
                            <option value="15">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_15_label"])}
                            </option>
                            <option value="25">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_25_label"])}
                            </option>
                            <option value="50">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_50_label"])}
                            </option>
                            <option value="75">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_75_label"])}
                            </option>
                            <option value="100">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_100_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.image.size_description"
                                defaultMessage="Size of the image (percentage of the document width)"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="alignment">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.image.alignment_label"
                            defaultMessage="Alignment"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="alignment"
                            value={this.state.alignment}
                            onChange={this.handleFormChange}
                            id="alignment"
                            className="form-control"
                        >
                            <option value="left">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_left_label"])}
                            </option>
                            <option value="center">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_center_label"])}
                            </option>
                            <option value="right">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_right_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.image.alignment_description"
                                defaultMessage="Horizontal alignment of the image"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="linkUrl">
                        <FormattedMessage
                            id="templates.form.edit.content.imagerow.linkUrl_label"
                            defaultMessage="Link to website"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="linkUrl"
                            value={this.state.linkUrl}
                            onChange={this.handleFormChange}
                            id="linkUrl"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage(messages['templates.sections.form.edit.content.image.linkUrl_placeholder'])}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.image.linkUrl_description"
                                defaultMessage="Optional link to be inserted on the image"
                            />
                        </small>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ImageContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/image/input.component.jsx